<template>
    <div class="row">
        <!--Title-->
        <div class="mb-3 text-right col-md-12">
                <h4 class="title center-title pull-left">Ingresos al sistema</h4>
        </div>
        <!--./Title-->
        <!--Loading state-->
        <loading :active.sync="this.$apollo.queries.accessAttempts.loading"
        :can-cancel="false" 
        :is-full-page="fullPage">
        </loading>
        <!--./Loading state-->
        <!--Sending state-->
        <loading :active.sync="isSending"
        :can-cancel="false" 
        :is-full-page="fullPage">
        </loading>
        <!--./Sending state-->
        <!--Empty state-->
        <div v-if="tableData && !tableData.length && !this.$apollo.queries.accessAttempts.loading" class="mt-3 col-md-12 card">
        <div class="card-header">
        </div>
        <div class="card-body">
            <img class="no_data_center"  v-bind:src="no_data_image" alt="">
        </div>
        <div class="card-footer text-center">
    
        </div>
        </div>
        <!--./Empty state-->
        <!--Filter data-->
        <div class="col-md-12 card">
            <form>
            <div class="card-header">
                <div class="category">Selecciona las fechas</div>
            </div>
            <div class="card-body row">
                <div class="col-md-6">
                    <div class="form-group">
                        <label>Fecha inicial</label>
                        <el-date-picker
                            v-model="model.startdate"
                            type="datetime"
                            placeholder="Seleccione fecha inicial">
                        </el-date-picker>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label>Fecha final</label>
                        <el-date-picker
                            v-model="model.enddate"
                            type="datetime"
                            placeholder="Seleccione fecha final">
                        </el-date-picker>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label>Usuario</label>
                        <fg-input   
                                    type="text"
                                    name="user"
                                    autocomplete="off"
                                    :error="getError('user')">
                                <el-select class="select-warning"
                                        size="large"
                                        placeholder="Seleccione usuario..."
                                        v-model="model.user">
                                <el-option v-for="option in users_array"
                                        class="select-warning"
                                        :value="option.id"
                                        :label="option.name+' '+option.surname"
                                        :key="option.id">
                                </el-option>
                            </el-select>
                        </fg-input>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label>Tipo</label>
                        <fg-input   
                                    type="text"
                                    name="tipo"
                                    autocomplete="off"
                                    :error="getError('tipo')">
                                <el-select class="select-warning"
                                        size="large"
                                        placeholder="Seleccione tipo..."
                                        v-model="model.attempt_type">
                                <el-option 
                                        class="select-warning"
                                        value="LOGIN_SUCCESS"
                                        label="Autenticado con éxito">
                                </el-option>
                                <el-option 
                                        class="select-warning"
                                        value="LOGOUT_SUCCESS"
                                        label="Sesión cerrada con éxito">
                                </el-option>
                                <el-option 
                                        class="select-warning"
                                        value="LOGIN_FAILED"
                                        label="Intento fallido de autenticación">
                                </el-option>
                            </el-select>
                        </fg-input>
                    </div>
                </div>
            </div>
            <div class="card-footer">
                <div class="text-right">
                    <p-button @click.prevent="validate" type="success">Aceptar</p-button>
                    <p-button @click="cancelForm()" type="default" class="pull-left">Cancelar</p-button>
                </div>
            </div>
            </form>
        </div>
        <!--/Filter data-->
        <!--usuarios data-->
        <div v-if="tableData &&  tableData.length && !this.$apollo.queries.accessAttempts.loading" class="col-md-12 card">
        <div class="card-header">
            <div class="category">Lista de ingresos</div>
        </div>
        <div class="card-body row">
            <div class="col-sm-4">
                <div>
                    <fg-input class="input-sm"
                            placeholder="Buscar"
                            v-model="searchQuery"
                            addon-right-icon="nc-icon nc-zoom-split">
                    </fg-input>
                </div>
            </div>
            <div class="col-sm-12 mt-2">
            <el-table class="table-striped"
                        :data="queriedData"
                        border
                        style="width: 100%">
                <el-table-column v-for="column in tableColumns"
                                :key="column.label"
                                :min-width="column.minWidth"
                                :prop="column.prop"
                                :label="column.label">
                </el-table-column>
            </el-table>
            </div>
            <div class="col-sm-6 pagination-info">
            <p class="category">Mostrando {{from + 1}} a {{to}} de {{total}} registros</p>
            </div>
            <div class="col-sm-12 mt-2">
                <el-select
                    class="select-default pull-left"
                    v-model="pagination.perPage"
                    placeholder="Per page">
                    <el-option
                    class="select-default"
                    v-for="item in pagination.perPageOptions"
                    :key="item"
                    :label="item"
                    :value="item">
                    </el-option>
                </el-select>
                <p-pagination class="pull-right"
                                v-model="pagination.currentPage"
                                :per-page="pagination.perPage"
                                :total="pagination.total">
                </p-pagination>
            </div>
        </div>
        </div>
        <!--./usuarios data-->
    </div>
    
    </template>
    <script>
    import swal from 'sweetalert2'
    import Vue from 'vue'
    import {Table, TableColumn, Select, Option, DatePicker, TimeSelect, Button} from 'element-ui'
    import PPagination from 'src/components/UIComponents/Pagination.vue'
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import { Tooltip } from 'element-ui'
    import gql from 'graphql-tag'
    import { accessAttempts } from 'src/api/graphql/queries/auth/AccessAttempts';
    import { users } from 'src/api/graphql/queries/user/AllUsers';
    import { offices } from 'src/api/graphql/queries/setup/AllOffices';
    import { regionals } from 'src/api/graphql/queries/setup/AllRegionals';
    import { CREATE_OFFICE } from 'src/api/graphql/mutations/setup/AddEditOffices';
    import { orderBy , sortBy , find } from 'lodash';
    import moment from 'moment'
    Vue.use(Table)
    Vue.use(TableColumn)
    Vue.use(Select)
    Vue.use(Option)
    export default{
        /***
        * Esta es la función para hacer todos los llamados de GraphQL al servidor mediante VueApollo
        *
        **/
        apollo:{
            users:    {
                    query: users,
                    skip: false,
                    fetchPolicy: 'network-only',
                    // Si tenemos un resultado, pero no encontró el slug.
                    result({ data, loading, networkStatus }) {
                        if(data.users.edges.length == 0)
                        {
                            this.users = [];
                        }
                        else
                        {
                            this.setUsers(data.users);
                            this.$apollo.queries.users.skip = true;
                        }
                        
                    },
                    // Si encontró algún error.
                    error(error) {
                        
                    },
                },
            accessAttempts:    {
                    query: accessAttempts,
                    variables() {
                        return {
                            user: this.user_fetch,
                            attemptTime_Gt: this.startdate_fetch,
                            attemptTime_Lt: this.enddate_fetch,
                            attemptType: this.attempt_type_fetch
                        }
                    },
                    skip() {
                        return this.skipAccessAttemptsQuery
                    },
                    fetchPolicy: 'network-only',
                    // Si tenemos un resultado, pero no encontró el slug.
                    result({ data, loading, networkStatus }) {
                        if(data.accessAttempts.edges.length == 0)
                        {
                            this.tableData = [];
                        }
                        else
                        {
                            this.setAccessAttempts(data.accessAttempts);
                        }
                    },
                    // Si encontró algún error.
                    error(error) {
                        
                    },
                },
            
        },
        components: {
        PPagination,
        Loading,
        [Tooltip.name]: Tooltip,
        [DatePicker.name]: DatePicker,
        [TimeSelect.name]: TimeSelect,
        [Button.name]: Button,
        },
        computed: {
        // startdate_computed () {
        //     if(this.model.startdate != ''){
        //         return moment(this.model.startdate).format();
        //     }
        //     else{
        //         return null
        //     }
        // },
        // enddate_computed () {
        //     if(this.model.enddate != ''){
        //         return moment(this.model.enddate).format();
        //     }
        //     else{
        //         return null
        //     }
        // },
        // user_computed () {
        //     if(this.model.user != ''){
        //         return this.model.user
        //     }
        //     else{
        //         return null
        //     }
            
        // },
        // attempt_type_computed () {
        //     if(this.model.attempt_type != ''){
        //         return this.model.attempt_type
        //     }
        //     else{
        //         return null
        //     }
        // },
        pagedData () {
            return this.tableData.slice(this.from, this.to)
        },
        /***
         * Searches through table data and returns a paginated array.
         * Note that this should not be used for table with a lot of data as it might be slow!
         * Do the search and the pagination on the server and display the data retrieved from server instead.
         * @returns {computed.pagedData}
         */
        queriedData () {
            if (!this.searchQuery) {
            this.pagination.total = this.tableData.length
            return this.pagedData
            }
            let result = this.tableData
            .filter((row) => {
                let isIncluded = false
                for (let key of this.propsToSearch) {
                let rowValue = row[key].toString().toLowerCase();
                if (rowValue.includes && rowValue.includes(this.searchQuery.toLowerCase())) {
                    isIncluded = true
                }
                }
                return isIncluded
            })
            this.pagination.total = result.length
            return result.slice(this.from, this.to)
        },
        to () {
            let highBound = this.from + this.pagination.perPage
            if (this.total < highBound) {
            highBound = this.total
            }
            return highBound
        },
        from () {
            return this.pagination.perPage * (this.pagination.currentPage - 1)
        },
        total () {
            this.pagination.total = this.tableData.length
            return this.tableData.length
        }
        },
        data () {
        return {
            datePicker: '',
            dateTimePicker: '',
            timePicker: '',
            no_data_image : process.env.VUE_APP_BASE_ROUTE+'img/system_logging.png',
            isSending: false,
            fullPage: false,
            tableData: [],
            users_array: [],
            access_attempts_array: [],
            skipAccessAttemptsQuery: true,
            addOffice : false,//Bandera de creación de usuarios
            editOffice : false,//Bandera de edición de usuarios
            rowEdit: {},
            formName: 'Cargando...',//Nombre del formulario de creación/edición
            model: {
                startdate: '',
                enddate: '',
                user:'',
                attempt_type:''
                
            },
            startdate_fetch: null,
            enddate_fetch: null,
            user_fetch:'',
            attempt_type_fetch:'',
            pagination: {
            perPage: 5,
            currentPage: 1,
            perPageOptions: [5, 10, 25, 50],
            total: 0
            },
            searchQuery: '',
            propsToSearch: ['user','username','group','office','attemptTypeDisplay','ipAddress'],
            tableColumns: [
            {
                prop: 'user',
                label: 'Usuario',
                minWidth: 200
            },
            {
                prop: 'username',
                label: 'Nombre de usuario',
                minWidth: 200
            },
            {
                prop: 'group',
                label: 'Rol',
                minWidth: 200
            },
            {
                prop: 'office',
                label: 'Sucursal',
                minWidth: 200
            },
            {
                prop: 'attemptTypeDisplay',
                label: 'Tipo',
                minWidth: 300
            },
            {
                prop: 'attemptTime',
                label: 'Fecha',
                minWidth: 300
            },
            {
                prop: 'ipAddress',
                label: 'IP',
                minWidth: 150
            },
            ],
        }
        },
        methods: {
            /**
             * Función para dar formato de hora a los datos de ingreso
             */
            setMoment() {
                var vm = this;
                vm.tableData.forEach(function(element){
                    element.attemptTime = vm.moment(element.attemptTime)
                });
            },
            /**
             * Función para dar formato de hora a los datos de ingreso
             */
            moment(date) {
                moment.locale('es');
                return moment(date).format('LL, h:mm a');
            },
            /**
             * Función para dar formato de hora a los datos de salida
             */
            momentOutput(date) {
                moment.locale('es');
                return moment(date).format();
            },
            /***
             * Función para setear en la tabla los datos que llegan desde el usuario
             */
            setUsers(users){
                var vm = this;
                for(let i=0;i<users.edges.length;i++)
                {
                    vm.pushUsersData(users.edges[i].node);
                }
                vm.orderUsersData();  
            },
            /***
             * Función para setear en la tabla los datos que llegan desde los intentos de acceso
             */
            setAccessAttempts(accessAttempts){
                var vm = this;
                vm.tableData = [];
                for(let i=0;i<accessAttempts.edges.length;i++)
                {
                    vm.pushData(accessAttempts.edges[i].node);
                }
                vm.orderData();
                vm.setMoment();
            },
            /*** 
            * Función que valida si se está enviando o cargando datos
            */
            handleLoading(){
            if(isLoading == true || isSending == true){
                return true
            }
            else{
                return false
            }
            },
            
            /**
            * Función para asignar el true o false a las opciones de agregar y editar oficinaes
            */
            setVisibleForm(add,edit)
            {
                this.addOffice = add;
                this.editOffice = edit;
            },
            
            /*** 
            * Función que cancela la creación/edición de usuarios y resetea los campos
            */
            cancelForm(){
                this.tableData = [];
                // this.startdate_fetch = ''; 
                this.model.startdate = '';
                // this.enddate_fetch = ''; 
                this.model.enddate = '';
                // this.user_fetch = ''; 
                this.model.user = '';
                // this.attempt_type_fetch = ''; 
                this.model.attempt_type = '';
                this.errors.clear();
                window.scrollTo(0,0);
                // this.$router.go();
            },
            /*** 
            * Función que permite visualizar los errores en cada campo del input
            */
            getError (fieldName) {
                return this.errors.first(fieldName)
            },
            /*** 
            * Función que muestra un mensaje en notificación tipo SweetAlert cuando sucede un registro exitoso
            */
            onSuccess(message){
                swal({
                    title: `¡Correcto!`,
                    text: message,
                    buttonsStyling: false,
                    confirmButtonClass: 'btn btn-success btn-fill',
                    type: 'success'
                });
            },
            /*** 
            * Función que muestra un mensaje en notificación tipo SweetAlert cuando sucede un registro erróneo
            */
            onError(message){
                swal({
                    title: `¡Alerta!`,
                    text: message,
                    buttonsStyling: false,
                    confirmButtonClass: 'btn btn-danger btn-fill',
                    type: 'error'
                });
            },
            /*** 
            * Función que oculta el formulario de creación/edición una vez realizado un envío de datos al servidor
            */
            reloadData(){
                var vm = this;
                vm.resetForm();
                vm.setVisibleForm(false,false)//Asignamos las variables de visualización del formulario 
            },
            /***
            * Función para agregar un objeto al arreglo de datos
            */
            pushUsersData(node){
                var vm = this;
                vm.users_array.push({
                    id: node.id,
                    name: node.name,
                    surname: node.surname,
                    username: node.username,
                });
            },
            /***
            * Función para agregar un objeto al arreglo de datos de intentos de acceso
            */
            pushData(node){
                var vm = this;
                if(node.user.creditanalyst != null){
                    vm.tableData.push({
                        id: node.id,
                        user: node.user.name+' '+node.user.surname,
                        username: node.user.username,
                        group: node.user.group.name,
                        office: node.user.creditanalyst.office.name,
                        attemptTypeDisplay: node.attemptTypeDisplay,
                        attemptTime: node.attemptTime,
                        attemptType: node.attemptType,
                        ipAddress: node.ipAddress,
                        userAgent: node.userAgent,
                        httpAccept: node.httpAccept,
                    });
                }
                else if(node.user.officedirector != null){
                    vm.tableData.push({
                        id: node.id,
                        user: node.user.name+' '+node.user.surname,
                        username: node.user.username,
                        group: node.user.group.name,
                        office: node.user.officedirector.office.name,
                        attemptTypeDisplay: node.attemptTypeDisplay,
                        attemptTime: node.attemptTime,
                        attemptType: node.attemptType,
                        ipAddress: node.ipAddress,
                        userAgent: node.userAgent,
                        httpAccept: node.httpAccept,
                    });
                }
                else{
                    vm.tableData.push({
                        id: node.id,
                        user: node.user.name+' '+node.user.surname,
                        username: node.user.username,
                        group: node.user.group.name,
                        office: 'N.A',
                        attemptTypeDisplay: node.attemptTypeDisplay,
                        attemptTime: node.attemptTime,
                        attemptType: node.attemptType,
                        ipAddress: node.ipAddress,
                        userAgent: node.userAgent,
                        httpAccept: node.httpAccept,
                    });
                }
                
            },
            /***
            * Función para ordenar el arreglo de datos de usuarios
            */
            orderUsersData(){
                var vm = this;
                const myOrderedArray = _.sortBy(vm.users_array, o => o.name);
                vm.users_array = myOrderedArray;
            },
            /***
            * Función para ordenar el arreglo de datos de intentos de acceso
            */
            orderData(){
                var vm = this;
                const myOrderedArray = _.orderBy(vm.tableData, ['attemptTime'], ['desc']);
                vm.tableData = myOrderedArray;
            },
            /***
            * Función para decodificar el ID en base 64
            */
            idDecode(id){
                let id_decoded = atob(id);
                return id_decoded.split(":")[1];
            },
            /***
             * Función para validar el formulario de edición y creación que se envía
             */
            validate () {
                this.$validator.validateAll().then(isValid => {
                if(isValid){
                    // this.$emit('on-submit', this.registerForm, isValid)
                    var vm = this;
                    vm.tableData = []
                    if((this.model.startdate != '' && this.model.enddate == '') || (this.model.startdate == '' && this.model.enddate != '')){
                        vm.onError('Las dos fechas son obligatorias');
                        return
                    }
                    if(this.model.startdate > this.model.enddate){
                        vm.onError('La fecha de inicio no puede ser mayor a la fecha de fin');
                        return
                    }
                    if (vm.model.startdate != '') {
                        vm.startdate_fetch = vm.momentOutput(this.model.startdate);
                        vm.enddate_fetch = vm.momentOutput(this.model.enddate);
                    }
                    vm.user_fetch = this.model.user;
                    vm.attempt_type_fetch = this.model.attempt_type;
                    this.skipAccessAttemptsQuery = false;
                    this.$apollo.queries.accessAttempts.refetch();
                }
                })
        }
        },
        mounted() {
            // this.test();
            // alert(this.$window.csrf_token);
        }
    }
    </script>
    <style lang="scss">
    .el-table .td-actions{
    button.btn {
        margin-right: 5px;
    }
    }
    // Función para centrar la imagen del Empty State
    .no_data_center {
        display: block;
        margin-left: auto;
        margin-right: auto;
        width: 70%;
    }
    // Estilos para poder centrar el título de el usuario
    .center-title {
        margin-top: 0;
        margin-bottom: 0;
    }
</style>
